import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=d9a0ad08&scoped=true&"
import script from "./BoardList.vue?vue&type=script&lang=js&"
export * from "./BoardList.vue?vue&type=script&lang=js&"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=d9a0ad08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0ad08",
  null
  
)

export default component.exports